/**
 * HAHA Toys - Shopify Theme JavaScript
 * Handles cart AJAX, animations, and interactive functionality
 */

(function() {
  'use strict';

  // ============================================
  // CART AJAX API
  // ============================================
  const CartAPI = {
    async getCart() {
      const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      return res.json();
    },

    async addItem(variantId, quantity = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!res.ok) throw new Error('Failed to add to cart');
      return res.json();
    },

    async updateItem(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      return res.json();
    },

    async removeItem(key) {
      return this.updateItem(key, 0);
    }
  };

  // ============================================
  // CART COUNT UPDATER
  // ============================================
  function updateCartCount(count) {
    const badges = document.querySelectorAll('.site-header__cart-count');
    badges.forEach(function(badge) {
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  // ============================================
  // ADD TO CART FORMS (AJAX)
  // ============================================
  function initAddToCartForms() {
    document.querySelectorAll('.product-card__add-to-cart').forEach(function(btn) {
      const form = btn.closest('form');
      if (!form) return;

      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1');

        btn.disabled = true;
        btn.innerHTML = '<span>Adding...</span>';

        try {
          await CartAPI.addItem(variantId, quantity);
          const cart = await CartAPI.getCart();
          updateCartCount(cart.item_count);
          btn.innerHTML = '<span>✓ Added!</span>';
          setTimeout(function() {
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg> Add to Cart';
            btn.disabled = false;
          }, 1500);
        } catch (err) {
          btn.innerHTML = '<span>Error</span>';
          setTimeout(function() {
            btn.innerHTML = 'Add to Cart';
            btn.disabled = false;
          }, 1500);
        }
      });
    });
  }

  // ============================================
  // SCROLL ANIMATIONS
  // ============================================
  function initScrollAnimations() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .category-card, .best-of-card, .about-value-card, .contact-card').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease-out, transform 0.5s ease-out';
      observer.observe(el);
    });
  }

  // ============================================
  // INIT ON DOM READY
  // ============================================
  document.addEventListener('DOMContentLoaded', function() {
    initAddToCartForms();
    initScrollAnimations();
  });

  // Export for use in templates
  window.HahaToys = {
    CartAPI: CartAPI,
    updateCartCount: updateCartCount
  };
})();
